import { ref } from 'vue';

const isOpen = ref(false);

// Composable function useProgressCircularLoader
export function useProgressCircularLoader() {
    return {
        isOpen,
        open() {
            isOpen.value = true;
        },
        close() {
            isOpen.value = false;
        },
    };
}

export type CircularLoaderType = ReturnType<typeof useProgressCircularLoader>;
